import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
};

const searchSlice = createSlice({
  name: 'searchSlice',
  initialState,
  reducers: {
    setLoading(state, { payload: toggle }: PayloadAction<boolean>) {
      state.isLoading = toggle;
    },
  },
});

export const { setLoading } = searchSlice.actions;
export default searchSlice;
